import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Header = styled.div`
  padding: 0;
  margin-bottom: 1.25rem;
`;

export const Footer = styled.div`
  margin: 1.5rem auto;
  display: flex;
  flex-direction: column;

  a {
    margin: 1rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
  }
`;
